import { render } from "./TechnopawsView.vue?vue&type=template&id=494c3e08&scoped=true"
import script from "./TechnopawsView.vue?vue&type=script&lang=js"
export * from "./TechnopawsView.vue?vue&type=script&lang=js"

import "./TechnopawsView.vue?vue&type=style&index=0&id=494c3e08&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-494c3e08"],['__file',"TechnopawsView.vue"]])

export default __exports__